import FeaturedProductItem from './FeaturedProductItem';
import { connect } from 'react-redux';
import {
    cartFeaturedProductsListSelector,
    cartFeaturedProductsListSelectorIsSelected,
} from '../../redux/selectors/cartSelector';
import { FEATURED_PRODUCTS_PAIR } from '../../constants/constants';

function FeaturedProducts({ featuredProductsList, mainProduct, productTotal }) {
    return (
        <>
            {featuredProductsList
                ?.filter((product) =>
                    FEATURED_PRODUCTS_PAIR[mainProduct.product_id]?.products?.includes(
                        product.product_id
                    )
                )
                ?.map((product) => (
                    <FeaturedProductItem
                        key={product?.product_id}
                        product={product}
                        productTotal={productTotal}
                        id={`FeaturedProductItem-${product?.product_id}`}
                    />
                ))}
        </>
    );
}

const mapStateToProps = (state) => ({
    featuredProductsList: cartFeaturedProductsListSelector(state),
    featuredProductIsSelected: cartFeaturedProductsListSelectorIsSelected(state),
});

export default connect(mapStateToProps)(FeaturedProducts);
